/**
 * PsicoSalud — Guarda de rutas autenticadas.
 *
 * Espera a que termine la restauración de sesión antes de decidir:
 * redirigir mientras el perfil aún se está recuperando expulsaría al
 * usuario en cada recarga de página.
 */

import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { useAuth } from '@/context/AuthContext';

export default function ProtectedRoute({ children }: { children: ReactNode }) {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();
  const { t } = useTranslation();

  if (isLoading) {
    return (
      <div className="empty-state" data-cy="auth-loading">
        {t('common.loading')}
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  return <>{children}</>;
}
